
import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertRateCardPurposeLov, convertTextToID } from "../../../../utils/GlobalFunction";
import { Constant } from "../../../../config/Constant";

export default class ManageRateCardAccountStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	deleteValues = null;
	viewValues = null;
	statusValues = null;
	total = 0;
	allColumnIds = [];
	dropdown_country_list = null;
	formField = null;
	zoneFormField = null;
	editZoneRateValues = null;
	validationErrorJson = null;
	viewZoneValues = null;
	editZoneValues = null;
	deleteZoneValues = null;
	dropdown_location_cash_list = null;
	errorMessage = null;
	draftValues = null;
	addCenterDetails = null;
	isArchived = 0;
	advance_filter = null;
	ManagecommonStoreObject = null;
	list_data_pincode = null;
	selectAllConvertRateCard = false;
	visibleRowCount = 0;
	selectedRowCount = 0;
	isSelectAll = false;
	convertRateCardValues = null;
	convertRateCardArr = [];
	expiryDateValues = null

	constructor(ManagecommonStoreObject) {
		this.ManagecommonStoreObject = ManagecommonStoreObject;
	}

	setIsArchived = (is_archived) => {
		this.isArchived = is_archived
	}

	setAddMoreValues = (data) => {
		this.formField = data;
	}

	setZoneAddMoreValues = (data) => {
		this.zoneFormField = data;
	}

	setZoneRateValues = (data) => {
		this.editZoneRateValues = data;
	}

	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	// set form values to edit
	setEditValues = (data) => {
		this.editValues = data;
	};

	refreshList = () => {
		if (this.agGrid) {
			this.agGrid.api.deselectAll();
			this.setupGrid(this.agGrid);
		}
	}

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to status
	setStatusValues = (data) => {
		this.statusValues = data;
	};

	setErrorMessage = (message) => {
		this.errorMessage = message;
	}

	setDraftValues = (data) => {
		this.draftValues = data;
	}

	setAddCenterDetails = (data) => {
		this.addCenterDetails = data
	}

	setIsArchived = (flag) => {
		this.isArchived = flag
	}

	setSelectAllConvertRateCard = (data) => {
		this.selectAllConvertRateCard = data
	}

	// set form values to  customefilter
	setAdvanceFilterValues = (data = null) => {
		if (this.agGrid) {
			this.agGrid.api.deselectAll();
			this.setupGrid(this.agGrid);
		}
		this.setConvertRateCardArr([]);
		this.setVisibleRowCount(0)
		this.setSelectedRowCount(0)
		this.advance_filter = data;
	};

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.deselectAll();
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	setListData = (data) => {
		if (this.agGridPincode) {
			var filter = this.agGridPincode.api.getFilterModel();
			var sort = this.agGridPincode.api.getSortModel();
		}
		this.list_data_pincode = data ? data : null;
		this.total_pincode = data.length;
		if (this.agGridPincode) {
			this.agGridPincode.api.setFilterModel(filter);
			this.agGridPincode.api.setSortModel(sort);
		}
	}

	// call api to get records
	getList = (payload) => {
		if (this.isArchived) {
			payload.is_archived = this.isArchived
		}
		return Axios.post(`/business/rate-card-account-party/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					if ((item.rcp_id === Constant.RATECARD_PURPOSE_ID.HO_OVERHEAD || item.rcp_id === Constant.RATECARD_PURPOSE_ID.FRANCHISEE_HO_OVERHEAD) && item.draft_id === null) {
						this.setVisibleRowCount(this.visibleRowCount + 1)
					}
					return null;
				});
			}
			if (this.visibleRowCount > 0 && this.visibleRowCount !== this.selectedRowCount) {
				this.setIsSelectAll(false)
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};
	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;

		if (final_filter["is_active"]) {
			final_filter['is_active'].values = convertTextToID(final_filter['is_active'], this.isActiveFilterList, 'name', 'id')
		}
		if (final_filter["rcp_id"]) {
			final_filter['rcp_id'].values = convertTextToID(final_filter['rcp_id'], this.ManagecommonStoreObject.dropdown_rate_card_purpose_list, 'name', 'id')
		}
		if (final_filter["convert_to_id"]) {
			final_filter['convert_to_id'].values = convertTextToID(final_filter['convert_to_id'], convertRateCardPurposeLov, 'name', 'id')
		}

		return { final_filter, final_sort }
	};

	//setAdvanceFilter
	setAdvanceFilter = () => {
		let setAdvanceFilter = {};
		if (this.advance_filter) {
			if ('tmpl_id' in this.advance_filter) {
				setAdvanceFilter.tmpl_id = this.advance_filter.tmpl_id;
			}
		}
		return setAdvanceFilter;
	}

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var advance_filter = this.setAdvanceFilter();
				var payload = {
					filter_data: filter_data.final_filter,
					advance_filter: advance_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					is_archived: this.isArchived,
					page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow))
				}
				this.getList(payload).then((data) => {
					if (data.list.total === 0) { this.agGrid.api.showNoRowsOverlay() }
					else { this.agGrid.api.hideOverlay() }
					params.successCallback(data.list.data, data.list.total)
					var allColumnIds = []
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id)
						})
					}
				})
			}
		};
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		if (this.agGrid) {
			this.agGrid.api.deselectAll();
			this.setupGrid(this.agGrid);
		}
		this.setConvertRateCardArr([]);
		this.setVisibleRowCount(0)
		this.setSelectedRowCount(0)
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// call api to get records
	getPreRequestData = () => {
		return Axios.get(`business/rate-card-account-party/pre-create`).then(({ data }) => {
			this.setAddMoreValues(data.view);
			return data;
		});
	};

	// Call add api
	AddData = (formdata) => {
		return Axios.post(`/business/rate-card-account-party/new`, formdata)
			.then(({ data }) => {
				// if (this.agGrid) {
				// 	this.setupGrid(this.agGrid);
				// }
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	//draft api
	Draft = (formdata) => {
		return Axios.post(`/business/rate-card-account-party/draft`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	}

	// Call edit api
	EditData = (formdata) => {
		return Axios.post(`/business/rate-card-account-party/edit/` + formdata.id, formdata)
			.then(({ data }) => {
				// if (this.agGrid) {
				// 	this.setupGrid(this.agGrid);
				// }
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return Axios.delete(`business/rate-card-cash/destroy/` + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	TogglePublishData = (formdata) => {
		const api_link = formdata.is_active === 1 ? "deactivate/" : "activate/";
		return Axios.patch("business/rate-card-cash/" + api_link + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	// call api to get records
	ViewData = (reqData, oldVersion = null) => {
		this.setViewValues(reqData);
		let formData = {};
		if (reqData?.rc_id) {
			formData.id = reqData.rc_id;
		} else {
			formData.id = reqData.id
		}
		formData.type = reqData.type;
		formData.history = 0;
		if (reqData.ver) {
			formData.ver = reqData.ver;
		}
		if (oldVersion) {
			formData.history = (oldVersion === reqData.ver) ? 0 : 1;
		}
		return Axios.post(`/business/rate-card-account-party/details`, formData).then(({ data }) => {
			let oldval = this.viewValues;
			let newval = { ...oldval, ...data.view };

			this.setViewValues(newval);
			this.setEditValues(newval);

			this.setAddMoreValues(data.pre_create);
			return data;
		});
	};

	//Get List of coutries for dropdown
	getRateCardTypeList = (conditional = {}) => {
		return Axios.post(`admin/rate-card-type/lov`, conditional)
			.then(({ data }) => {
				this.dropdown_rate_card_type_list = data.rate_card_type;
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	// call api to get Details By Zone	
	getDetailsByZoneData = (data) => {
		this.setZoneRateValues(data);
		let url = data?.rc_id ? `${data.rc_id}` : `${data.id}`;
		if (data?.rc_ver || data.ver) {
			url = data?.rc_ver ? `${url}/${data.rc_ver}` : `${url}/${data.ver}`
		}
		return Axios.get(`business/rate-card-account-party/details-by-zone/${url}`).then(({ data }) => {
			this.setZoneAddMoreValues(data.pre_create);
			let oldval = this.editZoneRateValues;
			let newval = { ...oldval, ...data.view };
			let oldViewval = this.editZoneRateValues;
			let newViewval = { ...oldViewval, ...data.view };
			this.setZoneRateValues(newval);
			this.setViewValues(newViewval)
			this.validationErrorJson = data.error_messages;
			return data;
		});
	};

	// Call add api
	ValidateZoneData = (formdata) => {
		return Axios.post(`business/rate-card-account-party/zone-validate`, formdata)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	AddZoneData = (formdata) => {
		return Axios.post(`business/rate-card-account-party/add-zone`, formdata)
			.then(({ data }) => {
				//this.getList();
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				this.getDetailsByZoneData(this.editZoneRateValues);
				let currentZoneField = this.zoneFormField;

				if (currentZoneField && currentZoneField.zones) {
					currentZoneField.zones.push({
						id: data.zone.id,
						name: data.zone.name,
						pin_cnt: data.zone.pin_cnt,
						is_completed: data.zone.is_completed
					});
					this.setZoneAddMoreValues(currentZoneField);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	EditZoneData = (formdata) => {
		return Axios.post(`business/rate-card-account-party/edit-zone/${formdata.id}`, formdata)
			.then(({ data }) => {
				// this.getList();
				this.getDetailsByZoneData(this.editZoneRateValues ?? this.viewValues);
				let currentZoneField = this.zoneFormField ?? this.formField;

				if (currentZoneField && currentZoneField.zones) {
					var index = currentZoneField.zones.findIndex(zone => zone.id === formdata.id);
					currentZoneField.zones.splice(index, 1, {
						id: data.zone.id,
						name: data.zone.name,
						pin_cnt: data.zone.pin_cnt
					});
					this.setZoneAddMoreValues(currentZoneField);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// set form values to view
	setZoneViewValues = (data) => {
		if (data && data.pincode) {
			this.setListData(data.pincode);
		}
		this.viewZoneValues = data;
	};

	// set form values to view
	setZoneEditValues = (data) => {
		this.editZoneValues = data;
	};

	setZoneDeleteValues = (data) => {
		this.deleteZoneValues = data;
	};

	// call api to get records
	ViewZoneData = (id, rc_id) => {
		return Axios.get(`/business/rate-card-account-party/get-zone/${rc_id}/${id}`).then(({ data }) => {
			this.setZoneViewValues(data.view);
			return data;
		});
	};

	// Call delete api
	DeleteZoneData = (formdata) => {
		return Axios.delete(`business/rate-card-account-party/delete-zone/${formdata.client_id}/${formdata.rc_id}/${formdata.id}`)
			.then(({ data }) => {
				//this.getList();
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				this.getDetailsByZoneData(this.editZoneRateValues ?? this.viewValues);
				let currentZoneField = this.zoneFormField ?? this.formField;;

				if (currentZoneField && currentZoneField?.zones) {
					currentZoneField.zones = currentZoneField.zones.filter(zone => zone.id !== formdata.id);
					this.setZoneAddMoreValues(currentZoneField);
				}else {
					this.setZoneAddMoreValues(null)
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};


	setIsActiveFilterList = (data) => {
		this.isActiveFilterList = data;
	}

	setCompletedFilterList = (data) => {
		this.isCompletedFilterList = data;
	}

	getLocationCashRateCard = (conditional = {}) => {
		return Axios.post(`/business/rate-card-cash/centers`, conditional)
			.then(({ data }) => {
				this.dropdown_location_cash_list = data.cash_rate_card_center
				return data
			}).catch((response) => {
				return Promise.reject(response);
			})
	}

	ConvertRateCardData = (formData) => {
		return Axios.post(`/business/rate-card-account-party/convert-rate-card`, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
					this.setSelectedRowCount(0)
					this.setIsSelectAll(false)
					this.setConvertRateCardValues(null)
					this.setConvertRateCardArr([]);
					this.setVisibleRowCount(0);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	ExpiryDateData = (formData) => {
		return Axios.post(`/business/rate-card-account-party/update-expiry-date`, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
					this.setSelectedRowCount(0)
					this.setIsSelectAll(false)
					this.setExpiryDateValues(null)
					this.setConvertRateCardArr([]);
					this.setVisibleRowCount(0);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	firstConvertRateCard = () => {
		if (this.selectAllConvertRateCard === true) {
			this.agGrid.api.forEachNode((node) => {
				if ((node.data?.rcp_id === Constant.RATECARD_PURPOSE_ID.HO_OVERHEAD || node.data?.rcp_id === Constant.RATECARD_PURPOSE_ID.FRANCHISEE_HO_OVERHEAD) && node.data?.draft_id === null) {
					this.setSelectedRowCount(this.selectedRowCount + 1)
					node.setSelected(true);
				}
			});
		}
	};

	convertRateCardSelectAllRender = (selectAllFlag) => {
		if (selectAllFlag === true) {
			this.firstConvertRateCard();
		} else {
			this.agGrid.api.forEachNode((node) => {
				this.setSelectedRowCount(0);
				node.setSelected(false);
			});
		}
	};
	

	setVisibleRowCount = (data) => {
		this.visibleRowCount = data;
	}

	setSelectedRowCount = (data) => {
		this.selectedRowCount = data;
	}

	setIsSelectAll = (selectFlag) => {
		this.isSelectAll = selectFlag;
	}

	setConvertRateCardValues = (data) => {
		this.convertRateCardValues = data;
	}

	setExpiryDateValues = (data) => {
		this.expiryDateValues = data;
	}

	setConvertRateCardArr = (data) => {
		this.convertRateCardArr = data;
	}

	doExportDownload = (data) => {
        return Axios.get(`/business/rate-card-account-party/print/${data.client_id}/${Constant.RATE_CARD_TYPE_ID.ACCOUNT}`)
            .then(({ data }) => {
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) {
                        notify = NOTIFICATION[0];
                    }
                    Object.keys(fieldErrors).forEach((name) => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };
}

decorate(ManageRateCardAccountStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	statusValues: observable,
	dropdown_rate_card_type_list: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	setEditValues: action,
	setDeleteValues: action,
	setStatusValues: action,
	getList: action,
	getStatesList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	formField: observable,
	zoneFormField: observable,
	editZoneRateValues: observable,
	AddZoneData: action,
	EditZoneData: action,
	DeleteZoneData: action,
	validationErrorJson: observable,
	setZoneEditValues: action,
	viewZoneValues: observable,
	editZoneValues: observable,
	deleteZoneValues: observable,
	setIsActiveFilterList: action,
	setCompletedFilterList: action,
	dropdown_location_cash_list: observable,
	errorMessage: observable,
	draftValues: observable,
	addCenterDetails: observable,
	isArchived: observable,
	setIsArchived: action,
	advance_filter: observable,
	setAdvanceFilterValues: action,
	setSelectAllConvertRateCard: action,
	selectAllConvertRateCard: observable,
	setVisibleRowCount: action,
	visibleRowCount: observable,
	setSelectedRowCount: action,
	selectedRowCount: observable,
	setIsSelectAll: action,
	isSelectAll: observable,
	setConvertRateCardValues: action,
	convertRateCardValues: observable,
	setConvertRateCardArr: action,
	convertRateCardArr: observable,
	setExpiryDateValues: action,
	expiryDateValues: observable
});
